import React from "react";
import { UserRound } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatToday } from "../../utils/date";

interface SalesCardProps {
  name: string;
  assigneeId: string;
  todayContacted: number;
  todayPotential: number;
  todayEnrolled: number;
  todayLost: number;
  totalContacted: number;
  totalPotential: number;
  totalEnrolled: number;
  totalLost: number;
}

export default function SalesCard({
  name,
  assigneeId,
  todayContacted,
  todayPotential,
  todayEnrolled,
  todayLost,
  totalContacted,
  totalPotential,
  totalEnrolled,
  totalLost,
}: SalesCardProps) {
  const navigate = useNavigate();

  const handleNavigate = (status: string, date?: string) => {
    navigate("/leads", {
      state: {
        filterStatus: status,
        assigneeId: assigneeId,
        lastTouchedDate: date,
      },
    });
  };

  const todayStr = formatToday();

  return (
    <div>
      <div className="w-full max-w-md rounded-xl bg-white p-2 shadow-sm border border-gray-200">
        <h3 className="text-base font-semibold text-gray-900">{name}</h3>

        <div className="mt-1">
          <p className="text-xs font-semibold text-gray-500">TODAY</p>

          <div className="grid grid-cols-4 gap-2">
            <button
              className="rounded-lg bg-blue-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Contacted", todayStr)}
            >
              <p className="text-[10px] text-blue-600">Contacted</p>
              <p className="mt-1 text-2xl font-semibold text-blue-900">
                {todayContacted}
              </p>
            </button>

            <button
              className="rounded-lg bg-green-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Potential", todayStr)}
            >
              <p className="text-[10px] text-green-600">Potential</p>
              <p className="mt-1 text-2xl font-semibold text-green-900">
                {todayPotential}
              </p>
            </button>

            <button
              className="rounded-lg bg-orange-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Enrolled", todayStr)}
            >
              <p className="text-[10px] text-orange-600">Enrolled</p>
              <p className="mt-1 text-2xl font-semibold text-orange-900">
                {todayEnrolled}
              </p>
            </button>

            <button
              className="rounded-lg bg-red-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Lost", todayStr)}
            >
              <p className="text-[10px] text-red-600">Lost</p>
              <p className="mt-1 text-2xl font-semibold text-red-900">
                {todayLost}
              </p>
            </button>
          </div>
        </div>

        <div className="mt-1">
          <p className="text-xs font-semibold text-gray-500">TOTAL</p>

          <div className=" grid grid-cols-4 gap-2">
            <button
              className="rounded-lg bg-blue-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Contacted")}
            >
              <p className="text-[10px] text-blue-700">Contacted</p>
              <p className="mt-1 text-2xl font-semibold text-blue-900">
                {totalContacted}
              </p>
            </button>

            <button
              className="rounded-lg bg-green-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Potential")}
            >
              <p className="text-[10px] text-green-700">Potential</p>
              <p className="mt-1 text-2xl font-semibold text-green-900">
                {totalPotential}
              </p>
            </button>

            <button
              className="rounded-lg bg-orange-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Enrolled")}
            >
              <p className="text-[10px] text-orange-600">Enrolled</p>
              <p className="mt-1 text-2xl font-semibold text-orange-900">
                {totalEnrolled}
              </p>
            </button>

            <button
              className="rounded-lg bg-red-50 p-1 hover:shadow-md transition-shadow duration-200 cursor-pointer"
              onClick={() => handleNavigate("Lost")}
            >
              <p className="text-[10px] text-red-600">Lost</p>
              <p className="mt-1 text-2xl font-semibold text-red-900">
                {totalLost}
              </p>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
